import classnames from "classnames";
import { nanoid } from "nanoid";
import Banner from "../../../components/common/Banner/Banner";
import BannerType from "../../../global/banner-type";
import classes from "../../../styles/Home.module.scss";

function OurProducts({ platforms, className }) {
  return (
    <div className={className}>
      <div className={classnames(classes.heading, "heading")}>
        Our Platforms
      </div>
      <div className={classnames(classes.flex_box, "bannerSty")}>
        {platforms.map(platform => {
          return (
            <Banner
              type={BannerType.PLATFORMS_BANNER}
              {...platform}
              key={nanoid()}
              className={classes.alignCenter}
            />
          );
        })}
      </div>
    </div>
  );
}
export default OurProducts;
